import { IOfferCard } from '../../../types';
import { isFlat } from './isFlat';

export const getAgentExperience = (offerCard: IOfferCard) => {
  const { offerUser: user } = offerCard;

  if (!user || !isFlat(offerCard) || user.masterAgent || offerCard.isByHomeowner || !user.experience) {
    return undefined;
  }

  const { experience } = user;
  const experienceNumber = Number(experience);

  switch (true) {
    case offerCard.newbuilding?.isFromSeller:
      return isNaN(experienceNumber) ? `На рынке ${experience}` : `Год основания: ${experience}`;

    case offerCard.offerUser?.accountType === 'agency':
      return isNaN(experienceNumber) ? `На рынке ${experience}` : `На рынке с ${experience} г.`;

    case offerCard.offerUser?.isAgent:
      return isNaN(experienceNumber) ? `Опыт: ${experience}` : `Опыт: с ${experience} г.`;

    default:
      break;
  }

  return undefined;
};
